// shared drum pad config — softened therapeutic colors, still distinguishable
export const PADS = [
  { id: "djembe", label: "DJEMBE", color: "#c46a58", rgb: "196,106,88" },   // soft terracotta
  { id: "conga", label: "CONGA", color: "#b89556", rgb: "184,149,86" },     // muted ochre
  { id: "tom", label: "TOM", color: "#5b7a99", rgb: "91,122,153" },         // slate blue
  { id: "slap", label: "SLAP", color: "#6b8f71", rgb: "107,143,113" },      // sage green
  { id: "clap", label: "CLAP", color: "#a87ea8", rgb: "168,126,168" },      // soft mauve
  { id: "shaker", label: "SHAKER", color: "#5fa4a0", rgb: "95,164,160" },   // soft teal
];
